<div *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>


<mat-card class="content-card">
  <div>
    <b>Upload Total Transactions report</b>
  </div>
  <div style="margin-top: 10px;">
    Upload a XLS or XLSX file here. The file must contains 2 worksheets, one named "Bericht 1" containing transactions and one named "Bericht 2" containing customers.
  </div>
  <div>
    <app-file-upload-xls *appHasRoles="['admin']" (upload)="onUpload($event)"></app-file-upload-xls>
  </div>

</mat-card>
<mat-card class="content-card">

  <app-mat-table-generator #table
                           tableName="totalStatsImportsTable"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [multiselectEnabled]="multiselectEnabled()"
                           [viewLink]="getViewLink"
                           [useEmbededFilter]="false"
                           [rowClassCallback]="getRowClass"
                           [deleteEnabled]="deleteEnabled()">
  </app-mat-table-generator>

</mat-card>
